export default __webpack_public_path__ + "35ceb04b57125ddc5df888341dc691f3.png";